export default "__VITE_ASSET__C6eFTD$u__"